"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.atDocument = exports.atWindow = void 0;
var minDom = {
    addEventListener: function (x, y) { return null; },
    dispatchEvent: function (event) { return null; },
    createElement: function (tagName, options) { return null; },
    getElementsByTagName: function (tag) { return null; },
    getElementById: function (tag) { return null; },
    createDocumentFragment: function () { return null; },
};
function atWindow() {
    return typeof window !== 'undefined' ? window : {};
}
exports.atWindow = atWindow;
function atDocument() {
    return typeof document !== 'undefined' ? document : minDom;
}
exports.atDocument = atDocument;
